import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

export const organizationLegalDocumentTemplateCategory = createCrudVuexModule({
  namespaced: true,
  path: "/legal-document-template-category",
});

export const organizationLegalDocumentTemplate = createCrudVuexModule({
  namespaced: true,
  path: "/legal-document-template",
  actions: {
    async addFromLibrary({ commit }, payload) {
      commit("isUpdating", true);
      try {
        const response = await rest.post("/legal-document-template/add-from-library", { libraryItemId: payload.libraryItem._id });
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    /** TKP-91 — sihirbazın canlı önizlemesi: hiçbir şey kaydedilmez. */
    async preview({ commit }, { template, criteria, renderSingleDocument }) {
      // TKP-197: md.38 "tek metin / ayrı metin" seçimi de gider (eskiden düşüyordu)
      const response = await rest.post("/legal-document-template/preview", { template, criteria, renderSingleDocument });
      return response;
    },
    /** TKP-197 — sihirbaz filtre seçenekleri: envanterde geçen tekil değerler, diğer seçimlere göre daralmış. */
    async filterOptions(_ctx, { criteria }) {
      return rest.post("/legal-document-template/filter-options", { criteria });
    },
    /** TKP-91 — sihirbazın son adımı: metin üretilir ve doğrudan yayımlanır. */
    async generate({ commit }, { template, criteria, renderSingleDocument }) {
      commit("isUpdating", true);
      try {
        return await rest.post("/legal-document-template/generate", { template, criteria, renderSingleDocument });
      } finally {
        commit("isUpdating", false);
      }
    },
    async prepare({ commit }, id) {
      commit("isUpdating", true);
      try {
        const response = await rest.get(`/legal-document-template/prepare/${id}`);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
  },
});

export const organizationLegalDocument = createCrudVuexModule({
  namespaced: true,
  path: "/legal-document",
  state: { tab: "document" },
  getters: {
    tab: (state) => state.tab,
  },
  mutations: {
    tab: (state, value) => (state.tab = value),
  },
  actions: {
    /**
     * TKP-94 md.15: hiçbir metnin kapsamına girmemiş süreçler. Doğrudan DİZİ döner (çağıran şekil tahmin etmesin).
     * DİKKAT: bu modül nesnesinde `actions` YALNIZ BİR KEZ bulunabilir — ikinci bir `actions` anahtarı JavaScript'te
     * öncekini sessizce ezer ve eylem hiç kaydolmaz (Vuex de bilinmeyen eylemde `undefined` döndürüp sessiz kalır).
     */
    async uncoveredProcesses(_ctx, kind) {
      // TKP-246: kind=CONSENT → açık rıza dayanaklı olup açık rıza metni olmayan süreçler; varsayılan aydınlatma
      const response = await rest.get(`/legal-document/uncovered-processes${kind ? `?kind=${kind}` : ""}`);
      const body = response?.data;
      return Array.isArray(body) ? body : body?.docs ?? [];
    },
    /** TKP-246: envanteri (INVENTORY) ya da şablonu (TEMPLATE) metin üretildikten sonra değişen metinler. Doğrudan DİZİ döner. */
    async changes(_ctx, reason) {
      const response = await rest.get(`/legal-document/changes/${reason}`);
      const body = response?.data;
      return Array.isArray(body) ? body : body?.docs ?? [];
    },
    async approve({ commit }, { id, fileCategoryId, fileNo, admin, isPeriodical, period }) {
      commit("isUpdating", true);
      try {
        const response = await rest.post(`/legal-document/approve/${id}/${fileCategoryId}/${fileNo}`, { admin, isPeriodical, period });
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
  },
});
